/**************************************************
 * Nombre:       Seccion_Formacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Formacion_Portada from "./Componentes/Formacion_Portada";
import Formacion_Certifiquese from "./Componentes/Formacion_Certifiquese";
import Formacion_Centro from "./Componentes/Formacion_Centro";
import Formacion_Modulos from "./Componentes/Formacion_Modulos";
import Formacion_Contactos from "./Componentes/Formacion_Contactos";
import {SECCIONES} from "../../Constantes";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import Footer from "../Footer";

const Seccion_Formacion = () => {
    const parms = useParams();
    const [curso, setCurso] = useState({});

    useEffect(() => {

        if (parms && parms.id) {
            obtenerDoc('cursos', parms.id).then((dox) =>{
                if (dox.res && dox.data){
                    setCurso(dox.data);
                }else{

                    obtenerCol('cursos').then((dox) =>{
                        if (dox.res && dox.data[0]){
                            setCurso(dox.data[0]);
                        }
                    })

                }
            })
        }else{

           obtenerCol('cursos').then((dox) =>{
               if (dox.res && dox.data[0]){
                   setCurso(dox.data[0]);
               }
           })
        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -1.5}}>
                <Formacion_Portada item={curso}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -8}}>
                <Formacion_Certifiquese item={curso}/>
            </Grid>

            <Grid id={SECCIONES[3]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 10}}>
                <Formacion_Centro item={curso}/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formacion_Modulos item={curso}/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formacion_Contactos item={curso}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Footer item={curso}/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Formacion    